// Module 24's sidebar contribution (contract 24 §11, v3 `components/Layouts/DefaultLayout.vue`).
//
// ══ WHAT THIS FILE DOES *NOT* CONTAIN, AND WHY ══════════════════════════════════════════════
// Module 08's `src/features/reports/nav.ts` already ships the Audience GROUP (`audienceGroup`,
// v3 :402–408 gate) with the two leaves whose pages 08 also owns: `demographicAnalysis`
// (v3 :410) and `rfmClustering` (v3 :427–437). The shell composes nav contributions by
// CONCATENATION (no merge-by-navKey), so re-declaring the group would render it twice —
// module 24 owns exactly the two leaves 08 deferred. NOTE the RFM placement: v3 live `main`
// puts the "RFM Analysis" leaf INSIDE the Audience group (`DefaultLayout.vue:427–437`), not
// under Ecommerce (Ecommerce's report-67 leaf at `:452` is Customer Intelligence, a different,
// nameless entry) — 08's placement is v3 parity and stays untouched.
//
// ══ ONLY `funnelExploration` IS REGISTERED — `userBehavior` IS WITHHELD ON PURPOSE ══════════
// `registerShellNavigation.ts` picks `funnelExploration` out of this array and composes it into
// 08's `audienceGroup`; ORP-18913 shipped its FunnelApi/store/chart, so that leaf is live.
//
// `userBehavior` is deliberately NOT registered, and this is a ratified decision rather than
// unfinished work — re-verified for ORP-20382 (2026-08-07):
//   * v3 has NO User Behavior sidebar leaf. Its entry is commented out on BOTH `origin/main` and
//     `origin/dev` (`DefaultLayout.vue`, inside the Audience group's `children`); a repo-wide grep
//     of that file returns zero live `UserBehavior` references. Registering here would INVENT a
//     surface v3 never shows, not restore parity. (Line anchors are omitted on purpose — the v3
//     file drifts, and the previous `:420–426`/`:574` anchors had already gone stale.)
//   * ORP-20041 — which shipped the native route and was promoted to main — recorded the same
//     call verbatim: "The v3-hidden nav leaf remains hidden. Route cutover did not invent new
//     sidebar visibility."
// Contract 24 §11 does sketch a `userBehavior` leaf, but that sketch transcribes v3's nav as it
// stood before the entry was commented out, and the same block misplaces RFM into Ecommerce (it
// lives in the Audience group) — so it is not authority to flip this on. Flipping it needs a
// PRODUCT decision, not a nav-registration ticket: that question is ORP-20411. Until it answers,
// this stays unregistered — do not re-open it as a missing-nav bug.
//
// The page is NOT unreachable: `/audience/user-behavior` is public, the legacy ingress targets it,
// and since ORP-20382 `?report_id=28` resolves here through the report page registry
// (`flows/registerAudiencePages.ts`) exactly as v3's `linksName` row does. Only the sidebar leaf
// is withheld. Because the leaf is unregistered, its `meta` search payload below never reaches
// `app/navigation/searchDestinations.ts` — that is the same deliberate invisibility, not a second
// defect, and it matches v3, whose search index is built from the same commented-out entry.
//
// `meta` carries v3's `search_value`/`importance` search-index payload verbatim (the ratified
// home, `app/navigation/types.ts:73–78`). Machine metadata, not UI copy — stays untranslated
// pending module 15.

export const audienceNavItems = [
  {
    // v3 `DefaultLayout.vue:411–419`. Gated on the ga4 INTEGRATION, not report availability —
    // the funnel is built from GA4 event metadata, so the gate is data-source presence.
    labelKey: 'audience.funnelExploration.title',
    navKey: 'funnelExploration',
    to: { name: 'FunnelExploration' },
    visibility: { control: 'integration' as const, id: ['ga4'] },
    meta: {
      importance: 7,
      searchValue:
        'Funnel Exploration section under Funnel Exploration analysis. Explore user journeys via Google Analytics, BigQuery, and Adjust data. Identify where users drop off and optimize funnel steps. adjust analysis analytics and bigquery data drop exploration explore funnel google identify journeys off optimize section steps under user users via where Funnel Open Funnel Close Funnel Fallout Funnel Baseline Funnel Daily Breakdown',
    },
  },
  {
    // Kept in sync with v3's commented-out Audience child (see header): gate, importance and
    // search payload come from that block; the route name from v3 `router/routes/app.js:61`.
    // Exported for the day the product decision lands — NOT registered today.
    labelKey: 'audience.userBehavior.title',
    navKey: 'userBehavior',
    to: { name: 'UserBehavior' },
    visibility: { control: 'report' as const, id: [28] },
    meta: {
      importance: 8,
      searchValue:
        'User Behavior section under User Behavior analysis. Analyze in-site user actions using Google Analytics data. Understand session paths, engagement, and behavioral patterns. actions analysis analytics analyze and behavior behavioral data engagement google in-site paths patterns section session under understand user using Behavioral Trends and Insights Page Per Session Avg. Order Value Conversion Rate Avg. Session Duration Key Demographics Top Locations Top Channels Top Session Windows Top Devices Categories Session Cohort Performance by Devices Trending Queries by Platform Performance by Pages',
    },
  },
]
